import { device } from "@src/theme";
import styled from "styled-components";

export const PlaylistOverviewHeader = styled.div`
  display: flex;
  height: 130px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const PlaylistOverviewHeaderLeft = styled.div`
  display: flex;
  flex: 2;
  height: 100%;
`;
export const PlaylistOverviewHeaderRight = styled.div`
  display: flex;
  flex: 2;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
`;
export const PlaylistOverviewHeaderCenter = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 130px;
  @media ${device.mobile} {
    display: none;
  }
  @media ${device.tablet} {
    display: none;
  }
  @media ${device.laptop} {
    display: flex;
  }
  @media ${device.desktop} {
    display: flex;
  }
`;

export const TotalLabel = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: ${({ theme }): string => theme.colors.yellow};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.tablet} {
    font-size: 18px;
  }
  @media ${device.laptop} {
    font-size: 20px;
  }
  @media ${device.desktop} {
    font-size: 22px;
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: ${(props): string => props.theme.margins.medium};
`;
export const BottomButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddActionButton = styled.button<{ $active?: boolean }>`
  background-color: ${({ $active, theme }): string =>
    $active ? theme.colors.yellow : theme.colors.darkGray};
  border: 1px solid
    ${({ $active, theme }): string =>
      $active ? theme.colors.darkGray : theme.colors.yellow};
  color: ${({ $active, theme }): string =>
    $active ? theme.colors.darkGray : theme.colors.yellow};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 32px;
`;

export const SearchInputWrapper = styled.div`
  flex: 2;
  display: flex;
  align-items: flex-end;
  width: 370px;
  max-width: 400px;

  @media ${device.mobile} {
    width: 80px;
  }
  @media ${device.tablet} {
    width: 100px;
  }
`;

export const TotalLabelWrapper = styled.div`
  padding: 5px 0px;
`;
